"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Timer = void 0;
var Timer = /** @class */function () {
  function Timer() {}
  Timer.prototype.start = function () {
    this.startTime = new Date();
  };
  Timer.prototype.stop = function () {
    this.endTime = new Date();
  };
  Timer.prototype.reset = function () {
    this.startTime = null;
    this.endTime = null;
  };
  Object.defineProperty(Timer.prototype, "milliseconds", {
    get: function () {
      if (!this.startTime || !this.endTime) {
        return 0;
      }
      return (this.endTime.getTime() - this.startTime.getTime()) % 1000;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Timer.prototype, "seconds", {
    get: function () {
      if (!this.startTime || !this.endTime) {
        return 0;
      }
      return Math.round((this.endTime.getTime() - this.startTime.getTime()) / 1000);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Timer.prototype, "minutes", {
    get: function () {
      return Math.round(this.seconds / 60);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Timer.prototype, "hours", {
    get: function () {
      return Math.round(this.seconds / 60 / 60);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Timer.prototype, "days", {
    get: function () {
      return Math.round(this.hours / 24);
    },
    enumerable: false,
    configurable: true
  });
  Timer.prototype.nn = function (n) {
    return n.toString().padStart(2, '0');
  };
  Timer.prototype.nnn = function (n) {
    return n.toString().padStart(3, '0');
  };
  Timer.prototype.format = function () {
    var _a = this,
      milliseconds = _a.milliseconds,
      seconds = _a.seconds,
      minutes = _a.minutes,
      hours = _a.hours,
      days = _a.days;
    var timeParts = [];
    if (days > 0 || hours > 0) {
      timeParts.push(this.nn(hours));
    }
    if (days > 0 || hours > 0 || minutes > 0) {
      timeParts.push(this.nn(minutes));
    }
    if (days > 0 || hours > 0 || minutes > 0 || seconds > 0) {
      timeParts.push(this.nn(seconds));
    }
    var time = days > 0 ? "".concat(days, " day(s) ") + timeParts.join(':') : timeParts.join(':');
    time = time.length > 0 ? "".concat(time, ".").concat(this.nnn(milliseconds)) : "".concat(milliseconds, "ms");
    return time;
  };
  return Timer;
}();
exports.Timer = Timer;
